import styled from 'styled-components'

interface RadioGroupWrapperProps {
  asColumn?: boolean,
  noBottomMargin?: boolean
}

export const RadioGroupWrapper = styled.div<RadioGroupWrapperProps>`
  line-height: 28px;
  flex-basis: 100%;
  margin-bottom: ${(props) => props.noBottomMargin ? '0' : '25px'};
  
  & .ant-radio-group {
    ${(props) => props.asColumn && `
      display: flex;
      flex-direction: column;
    `};
  }
  
  & .ant-radio-wrapper {
    font-size: 16px;
    margin-right: 45px;
    
    ${(props) => props.asColumn && `
      line-height: 28px;
      margin-bottom: 17px;
    `};
    
    &:last-child {
      margin-right: 0;
    }
  }
`
